

////////////////////////////////////////////////////////////////////////////////
// The drop down line and expanding circle animation
////////////////////////////////////////////////////////////////////////////////
var casesBackground = document.getElementById("casesBackground");
if(casesBackground) {

	var timeToStart           = 100;
	var timeToDrawLine        = timeToStart+700;
	var timeToSlimHeight      = timeToDrawLine+500;
	var timeUntilCircleToExpand = timeToSlimHeight+100;
	var completedAnimation = timeUntilCircleToExpand +2000;

	var bodytag = document.getElementById("body");
	bodytag.className += " body--white";


	$(window).on("load", function (e) {

		$('body').fadeIn(100);
		
		// Wait 1s to add the on class. The on class moves the container
		// down from the top.
		setTimeout(function() {
			casesBackground.className += " casesBackground--on";
		}, timeToStart);

		// Wait the time it takes for the container to go from the top
		// until the middle before adding the slim class which makes the container
		// as heigh as the circle.
		setTimeout(function() {
			casesBackground.className += " casesBackground--slim";
		}, timeToDrawLine);

		// When the animation of the container is ready, expand the circle.
		setTimeout(function() {
			casesBackground.className += " casesBackground--expand";
		}, timeUntilCircleToExpand);

		// Add a finished class
		setTimeout(function() {
			casesBackground.className += " casesBackground--finished";
		}, completedAnimation);
	});


} 

